import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";

@Component({
  selector: "app-efax-wizard",
  templateUrl: "./efax-wizard.component.html",
  styleUrls: ["./efax-wizard.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EfaxWizardComponent implements OnInit {
  @Input() wizardItems: string[] = [];
  @Input() activeStep: string;

  constructor() {}

  ngOnInit(): void {}
}
